'use client';

import React, { memo, RefObject } from 'react';
import { AudioFileFill } from '@crabs-ai/web-icons';
import { MediaContentAdapterProps } from '../types';

// rendering-hoist-jsx: 정적 className 호이스팅
const iconClassName =
  'size-[56px] [&_path]:fill-sys-cont-neutral-disabled-light';
const placeholderClassName =
  'flex h-[155px] w-[275px] items-center justify-center rounded-xs bg-sys-style-neutral-light';

/**
 * 오디오 미디어 어댑터
 * - <audio hidden> + AudioFileFill 아이콘 플레이스홀더
 * - rerender-memo: memo로 감싸 불필요 리렌더 차단
 */
export const AudioContent = memo(function AudioContent({
  url,
  mediaRef,
  onLoaded,
}: MediaContentAdapterProps) {
  return (
    <>
      <div className={placeholderClassName}>
        <AudioFileFill className={iconClassName} />
      </div>
      <audio
        ref={mediaRef as RefObject<HTMLAudioElement>}
        src={url}
        className="hidden"
        onLoadedMetadata={onLoaded}
      />
    </>
  );
});
